import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PlaceIcon from "@mui/icons-material/Place";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import { CheckCircle } from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import PublicIcon from "@mui/icons-material/Public";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";//MyEvents file
import { MatxLayoutSettings } from "app/components/MatxLayout/settings";
export function CalendarIcon({ sx = {}, ...props }) {
  return (
    <CalendarMonthIcon
      sx={{
        fontSize: { xs: 14, sm: 16 },
        color: MatxLayoutSettings.palette.active,
        flexShrink: 0,
        ...sx,
      }}
      {...props}
    />
  );
}

export function LocationIcon({ sx = {}, ...props }) {
  return (
    <PlaceIcon
      sx={{
        fontSize: { xs: 14, sm: 16 },
        color: MatxLayoutSettings.palette.active,
        flexShrink: 0,
        ...sx,
      }}
      {...props}
    />
  );
}

export function TimeLapseIcon({sx={},...props}){
    return (
    <TimelapseIcon
      sx={{
        fontSize: "20px",
        mb: 0.5,
        marginRight: 0.5,
        ...sx,
      }}
      {...props}
    />
  );

}

export function BackIcon({ sx = {}, ...props }) {
  return (
    <ChevronLeftIcon
      sx={{ ...sx }}
      color={MatxLayoutSettings?.palette?.black}
      {...props}
    />
  );
}

export function NoEventsIcon({ sx = {}, ...props }) {
  return (
    <EventBusyIcon
      sx={{ fontSize: 100, color: "gray", ...sx }}
      {...props}
    />
  );
}
export function ActiveEventsIcon({ sx = {}, ...props }) {
  return (
    <CheckCircle
      sx={{ fontSize: "20px", mb: 0.5, mr: 0.5, ...sx }}
      {...props}
    />
  );
}
export function PersonIcons({ sx = {}, ...props }) {
  return (
    <PersonIcon
      sx={{
        fontSize: { xs: 14, sm: 16 },
        color: MatxLayoutSettings.palette.active,
        ...sx,
      }}
      {...props}
    />
  );
}
export function GroupsIcons({ sx = {}, ...props }) {
  return (
    <GroupsIcon
      sx={{
        fontSize: { xs: 14, sm: 16 },
        color: MatxLayoutSettings.palette.active,
        flexShrink: 0,
        ...sx,
      }}
      {...props}
    />
  );
}
export function OrganizationIcon({ sx = {}, ...props }) {
  return (
    <HomeWorkIcon
      sx={{
        fontSize: { xs: 14, sm: 16 },
        color: MatxLayoutSettings.palette.active,
        flexShrink: 0,
        ...sx,
      }}
      {...props}
    />
  );
}
export function PublicEventIcon({ sx = {}, ...props }) {
  return (
    <PublicIcon
      sx={{
        fontSize: { xs: 14, sm: 16 },
        color: MatxLayoutSettings.palette.active,
        flexShrink: 0,
        ...sx,
      }}
      {...props}
    />
  );
}

export function LocalIcon({ sx = {}, ...props }) {
  return (
    <LocalActivityIcon
      sx={{
        fontSize: { xs: 14, sm: 16 },
        color: MatxLayoutSettings.palette.active,
        flexShrink: 0,
        ...sx, 
      }}
      {...props}
    />
  );
}
